import type { ReactNode } from 'react';
import ArrowLeftIcon from '@assets/icons/ArrowLeftIcon';
import styles from './StepBits.module.scss';

export function StepTitle({ children }: { children: ReactNode }) {
  return <h1 className={styles.title}>{children}</h1>;
}

export function StepSub({ children }: { children: ReactNode }) {
  return <p className={styles.sub}>{children}</p>;
}

export function BackLink({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button type="button" className={styles.backLink} onClick={onClick}>
      <ArrowLeftIcon />
      {label}
    </button>
  );
}
